import React from 'react';
import Image from '../Image';

export default class PostTypeResult extends React.Component {
    constructor(props) {
        super(props);
    }

    render = () => {
        const item = this.props.item;

        let issueSlug = item.permalink.split('/')[3];
        let month = issueSlug.split('-')[0];
        let year = issueSlug.split('-')[1];
        const mediaBase = item.postType === 'specialissue_content' ? 'special' : 'archive';
        let image = `https://media.motorsportmagazine.com/${mediaBase}/${issueSlug}/180px/${item.archivePage}.jpg`;
        let excerpt = item.content.replace(/(<([^>]+)>)/gi, '');
        excerpt =
            excerpt
                .split(' ')
                .slice(0, 15)
                .join(' ') + '...';

        return (
            <article className="article-item">
                <a className="article-item__link" href={item.permalink}>
                    <div className="article-item__image article-item__image--cropped">
                        <div className="article-item__issue">
                            <Image uri={image} nostyle={true} />
                        </div>
                    </div>
                    <div className="article-item__content">
                        <h2 className="article-item__title sanomat">{item.title}</h2>
                        <div className="article-item__excerpt">{excerpt}</div>
                        <div className="article-item__meta proxima">
                            <span className="article-item__date">
                                {month} {year} Issue
                            </span>
                            <div className="article-item__author">By {item.author}</div>
                        </div>
                    </div>
                </a>
            </article>
        );
    };
}
